declare var d3: any;
declare var gauger: any;

import { Injectable } from '@angular/core';
import '../../assets/libs/d3.v3.min.js';
import '../../assets/libs/liquidFillGauge.js';


@Injectable()
export class GaugeService {

  gauge2 = null;
  gauge4 = null;

  constructor() { }


  buildVisualization(anual, accu){
      this.gauge2 = null;
      this.gauge4 = null;
      this.gauge2 = gauger("fillgauge2", Math.round(10*anual)/10, true);
      this.gauge4 = gauger("fillgauge4", Math.round(10*accu)/10, false);
  }

}



// WEBPACK FOOTER //
// ./src/app/offers/gauge.service.ts